export const SUPPORTED_LOCALES = ['en', 'de'] as const

export type Locale = (typeof SUPPORTED_LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'en'

export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE'

export function isLocale(value: string | null | undefined): value is Locale {
  return !!value && SUPPORTED_LOCALES.includes(value as Locale)
}

/** Strip leading `/en` or `/de` from a pathname (middleware may prefix locale). */
export function stripLocalePrefix(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean)
  const first = segments[0]
  if (first && isLocale(first)) {
    const stripped = `/${segments.slice(1).join('/')}`
    return stripped === '/' ? '/' : stripped || '/'
  }
  return pathname || '/'
}

export function normalizeLocale(value: string | null | undefined): Locale {
  if (isLocale(value)) return value
  if (!value) return DEFAULT_LOCALE
  const lower = value.toLowerCase()
  if (lower.startsWith('de')) return 'de'
  return DEFAULT_LOCALE
}

export function detectLocaleFromAcceptLanguage(acceptLanguage: string | null): Locale {
  if (!acceptLanguage) return DEFAULT_LOCALE
  const primary = acceptLanguage.split(',')[0]?.trim()
  return normalizeLocale(primary)
}

